import { PERMISSIONS } from '@savgroup-front-common/constants/control';
import { useHasPermission } from '@savgroup-front-common/core/hooks';

const useHasBusinessIntelligencePermission = (): boolean => {
  return useHasPermission(PERMISSIONS.VIEW_ANALYTICS);
};

export default useHasBusinessIntelligencePermission;
